import React from "react";
import styles from "./Tab.module.scss";

const Tab = ({ stage, setStage }) => {
  return (
    <div className={styles.container}>
      <ul>
        <li
          className={stage === 0 ? styles.active : ""}
          onClick={() => setStage(0)}
        >
          Owner
        </li>
        <li
          className={stage === 1 ? styles.active : ""}
          onClick={() => setStage(1)}
        >
          Details
        </li>
        <li
          className={stage === 2 ? styles.active : ""}
          onClick={() => setStage(2)}
        >
          Transfer history
        </li>
      </ul>
    </div>
  );
};

export default Tab;
